export default __webpack_public_path__ + "static/media/List-documentation.db43485f.md";